// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__lMyrc","unreadBadge":"styles_unreadBadge__1jKJ0","modalContent":"styles_modalContent__1Usiz","modal":"styles_modal__3msop"};